import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../css/Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname.slice(1) || 'home'; // Remove leading slash and use 'home' as default

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavLinkClick = () => { if (window.innerWidth <= 768) { setIsMenuOpen(false); } };

    return (
        <header className={`header ${currentPath}`}>
            <div className="headerNav">
                <div>
                    <h1>
                        <button className="burgerMenuButton" onClick={toggleMenu}>
                            <img src='../menu icon.svg' width='27' alt="Menu Icon" />
                        </button>
                        <a href='/'>
                            <img src='../Engivio Login Logo.svg' width='123' alt="Engivio Logo" />
                        </a>
                    </h1>
                </div>
                <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                    <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
                        <li>
                            <NavLink onClick={handleNavLinkClick} to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
                                Today
                            </NavLink>
                        </li>
                        <li>
                            <NavLink onClick={handleNavLinkClick} to="/progress" className={({ isActive }) => (isActive ? 'active' : '')}>
                                Progress
                            </NavLink>
                        </li>
                        <li>
                            <NavLink onClick={handleNavLinkClick} to="/explore" className={({ isActive }) => (isActive ? 'active' : '')}>
                                Explore
                            </NavLink>
                        </li>
                        {isMenuOpen && (
                            <>
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/chat" className={({ isActive }) => (isActive ? 'active' : '')}>
                                        Chat
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/rom" className={({ isActive }) => (isActive ? 'active' : '')}>
                                        ROM
                                    </NavLink>
                                </li>
                            </>
                        )}
                    </ul>
                </nav>
                <div className='headerButtons'>
                    <a href="/chat" className="chatButton"><img src='../ChatFilled.svg' width="20" alt="Chat" />Chat</a>
                    <a href="/rom" className="romButton"><img src='../Angle.svg' width="20" alt="Rom" />Rom</a>
                </div>
            </div>
        </header>
    );
};

export default Header;
